import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {EntityData} from "@fedeltapointofsale/data-client";

/**
 * Column that provides a popup showing extra information
 */
@Component({
    selector: "wbo-info-text-column",
    templateUrl: "./info-text-column.component.html",
    styleUrls: ["info-text-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => InfoTextColumnComponent), multi: true}
    ]
})
export class InfoTextColumnComponent extends AbstractColumnComponent {

    @Input() fieldInfo: string;

    currentIndexShowing: number;
    currentIndexState: boolean;

    constructor(injector: Injector) {
        super(injector);
    }

    getInfoValue(dataItem: any): string {
        return this.fieldInfo ? EntityData.getField(dataItem, this.fieldInfo) : undefined;
    }

    toggle(index: number): void {
        if (index === this.currentIndexShowing) {
            this.currentIndexState = !this.currentIndexState;
        } else {
            this.currentIndexShowing = index;
            this.currentIndexState = true;
        }
    }

    poppedChange(popped: boolean, index: number): void {
        if (index === this.currentIndexShowing) {
            this.currentIndexState = popped;
        }
    }

    isOpen(index: number): boolean {
        return this.currentIndexShowing === index && this.currentIndexState;
    }
}
